/** Google Analytics 4 스크립트 로딩과 SPA page_view 전송을 담당한다. */
export class GoogleAnalytics {
  measurementId;

  initialized = false;

  enabled = false;

  lastPagePath;

  /** 활성화된 운영 환경에서 gtag 스크립트를 한 번만 초기화한다. */
  initialize({ measurementId, enabled }) {
    if (this.initialized) return;
    this.measurementId = measurementId;
    this.enabled = Boolean(enabled && measurementId);
    this.initialized = true;
    if (!this.enabled || typeof document === "undefined") return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    // React Router가 경로별 page_view를 직접 보내므로 자동 최초 전송은 끈다.
    window.gtag("config", this.measurementId, { send_page_view: false });

    if (!document.querySelector(`script[data-ga4='${this.measurementId}']`)) {
      const script = document.createElement("script");
      script.async = true;
      script.dataset.ga4 = this.measurementId;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(this.measurementId)}`;
      document.head.appendChild(script);
    }
  }

  /** 같은 경로의 중복 렌더를 제외하고 개인정보 없는 SPA 페이지 정보만 전송한다. */
  pageView(pagePath) {
    if (!this.enabled || !window.gtag || !pagePath || this.lastPagePath === pagePath) return;
    this.lastPagePath = pagePath;
    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_location: `${window.location.origin}${pagePath}`,
      page_title: document.title,
    });
  }
}

export const ga4 = new GoogleAnalytics();
